import { useMutation } from "@tanstack/react-query";
import type { Stripe, StripeElements } from "@stripe/stripe-js";

/**
 * Confirms a Stripe Payment Element payment (redirect: "if_required", so success resolves inline
 * without leaving the page unless the payment method itself requires an off-site redirect).
 * Shared mutation key so this action has one consistent cache identity anywhere in the shop it's
 * triggered from, rather than each call site inventing its own.
 */
export const useConfirmStripePayment = (
  stripe: Stripe | null,
  elements: StripeElements | null,
  onSuccess: () => void
) =>
  useMutation({
    mutationKey: ["shop", "confirmPayment"],
    mutationFn: async () => {
      if (!stripe || !elements) throw new Error("Stripe not ready");
      const { error } = await stripe.confirmPayment({
        elements,
        redirect: "if_required",
        confirmParams: { return_url: window.location.href },
      });
      if (error) throw error;
    },
    onSuccess,
  });
